import { ReduxStateHandler } from '../ReduxStateHandler';

export const ForcedExperimentVariantsStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_FORCED_EXPERIMENT_VARIANTS',
  statePath: 'forcedExperimentVariants',
});
